type Role = {
  USER: "USER";
  EMPLOYEE: "EMPLOYEE";
  ADMIN: "ADMIN";
  HR: "HR";
  TEACHER: "TEACHER";
  STUDENT: "STUDENT";
  COUNSELLOR: "COUNSELLOR";
  IT: "IT";
  ALLOWED_ADMIN_HR_TEACHER: string[];
  ADMINROLE: number;
  HRROLE: number;
  EMPLOYEEROLE: number;
  ITROLE: number;
  COUNSELLORROLE: number;
  TEACHERROLE: number;
  STUDENTROLE: number;
  ALLOWED_SALES_DEPT: string[];
  ALLOWED_HR_DEPT: string[];
  ALLOWED_ALL_DEPT: string[];
  ALLOWED_ALL_DEPT_EXPECT_ADMIN_HR: string[]
};

export const ROLE: Role = {
  USER: "USER",
  EMPLOYEE: "EMPLOYEE",
  ADMIN: "ADMIN",
  HR: "HR",
  TEACHER: "TEACHER",
  STUDENT: "STUDENT",
  COUNSELLOR: "COUNSELLOR",
  IT: "IT",

  // ROLE NUMBERS
  ADMINROLE: 1,
  HRROLE: 2,
  EMPLOYEEROLE: 4,
  ITROLE: 6,
  COUNSELLORROLE: 7,
  TEACHERROLE: 8,
  STUDENTROLE: 9,

  ALLOWED_ADMIN_HR_TEACHER: ["ADMIN", "HR", "TEACHER"],
  ALLOWED_SALES_DEPT: [
    "ADMIN",
    "HR",
    "TEACHER",
    "COUNSELLOR",
    "Admin",
    "Hr",
    "Teacher",
    "Counsellor",
  ],
  ALLOWED_ALL_DEPT_EXPECT_ADMIN_HR: [
    "Employee",
    "Manager",
    "Counsellor",
    "Teacher",
    "TEACHER",
    "COUNSELLOR",
    "IT",
    "MANAGER"

  ],
  ALLOWED_HR_DEPT: ["admin", "HR"],
  ALLOWED_ALL_DEPT: [
    "Admin",
    "Employee",
    "Manager",
    "HR",
    "Counsellor",
    "ADMIN",
    "EMPLOYEE",
    "COUNSELLOR",
    "Hr",
  ],
};
